
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";

interface HotelDetailsProps {
  hotelClass: string;
  setHotelClass: (value: string) => void;
  checkInTime: string;
  setCheckInTime: (value: string) => void;
  checkOutTime: string;
  setCheckOutTime: (value: string) => void;
  hasPool: boolean;
  setHasPool: (value: boolean) => void;
  hasSpa: boolean;
  setHasSpa: (value: boolean) => void;
  hasFitnessCenter: boolean;
  setHasFitnessCenter: (value: boolean) => void;
  hasRoomService: boolean;
  setHasRoomService: (value: boolean) => void;
  amenities: string;
  setAmenities: (value: string) => void;
  isExistingPlace?: boolean;
}

export function HotelDetails({
  hotelClass,
  setHotelClass,
  checkInTime,
  setCheckInTime,
  checkOutTime,
  setCheckOutTime,
  hasPool,
  setHasPool,
  hasSpa,
  setHasSpa,
  hasFitnessCenter,
  setHasFitnessCenter,
  hasRoomService,
  setHasRoomService,
  amenities,
  setAmenities,
  isExistingPlace = false
}: HotelDetailsProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>Hotel Class (stars)</Label>
        <Select 
          value={hotelClass} 
          onValueChange={setHotelClass}
          disabled={isExistingPlace}
        >
          <SelectTrigger className={isExistingPlace ? "bg-gray-50" : ""}>
            <SelectValue placeholder="Select hotel class" />
          </SelectTrigger>
          <SelectContent>
            {[1, 2, 3, 4, 5].map((stars) => (
              <SelectItem key={stars} value={String(stars)}>
                {'⭐'.repeat(stars)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Check-in Time</Label>
          <Input
            value={checkInTime}
            onChange={(e) => setCheckInTime(e.target.value)}
            placeholder="e.g., 3:00 PM"
            className={isExistingPlace ? "bg-gray-50" : ""}
            readOnly={isExistingPlace}
          />
        </div>

        <div className="space-y-2">
          <Label>Check-out Time</Label>
          <Input
            value={checkOutTime}
            onChange={(e) => setCheckOutTime(e.target.value)}
            placeholder="e.g., 11:00 AM"
            className={isExistingPlace ? "bg-gray-50" : ""}
            readOnly={isExistingPlace}
          />
        </div>
      </div>
      
      <div className="space-y-2">
        <Label>Amenities</Label>
        <Input
          value={amenities}
          onChange={(e) => setAmenities(e.target.value)}
          placeholder="Enter amenities separated by commas"
          className={isExistingPlace ? "bg-gray-50" : ""}
          readOnly={isExistingPlace}
        />
      </div>

      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <Switch
            checked={hasPool}
            onCheckedChange={setHasPool}
            disabled={isExistingPlace}
          />
          <Label className={isExistingPlace ? "text-muted-foreground" : ""}>
            Swimming Pool
          </Label>
        </div>

        <div className="flex items-center space-x-2">
          <Switch
            checked={hasSpa}
            onCheckedChange={setHasSpa}
            disabled={isExistingPlace}
          />
          <Label className={isExistingPlace ? "text-muted-foreground" : ""}>
            Spa
          </Label>
        </div>

        <div className="flex items-center space-x-2">
          <Switch
            checked={hasFitnessCenter}
            onCheckedChange={setHasFitnessCenter}
            disabled={isExistingPlace}
          />
          <Label className={isExistingPlace ? "text-muted-foreground" : ""}>
            Fitness Center
          </Label>
        </div>

        <div className="flex items-center space-x-2">
          <Switch
            checked={hasRoomService}
            onCheckedChange={setHasRoomService}
            disabled={isExistingPlace}
          />
          <Label className={isExistingPlace ? "text-muted-foreground" : ""}>
            Room Service
          </Label>
        </div>
      </div>
    </div>
  );
}
